module.exports = __webpack_public_path__ + "img/roles_9.7ff2ea79.png";